"use strict";

var app = angular.module('rmFormBuilder');

app.controller('FormBuilderFormCtrl', require('./formbuilder_form_ctrl'));